import React from 'react';
import PropTypes from 'prop-types';
import {observer} from 'mobx-react';
import {primary, white} from '../../themes/colors';
import CSSTransition from '../../components/CSSTransition';

const style = {
    top: 5,
    right: 5,
    position: 'absolute',
    width: 9,
    height: 9,
    fontSize: 12,
    letterSpacing: '0.5pt !important',
    borderRadius: '50%',
    border: `1px solid ${white}`,
    background: primary,
    color: white
};
const NotificationUnreadBadge = ({count, innerStyle, innerClassName}) => (
    <CSSTransition animation="pop" className="badge flex-center">
        {count > 0 && <div className={`flexbox badge-inner ${innerClassName}`} style={Object.assign({}, style, innerStyle)}/>}
    </CSSTransition>
);

NotificationUnreadBadge.propTypes = {
    count: PropTypes.number.isRequired
};
export default observer(NotificationUnreadBadge);
